import HttpClient from "../HttpClient";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";

export class VendorTipService {
    async getAllVendorTips(
        limit: number,
        offset: number,
        filters: any,
        sort: any,
      ) {
        let nullFilters: string[] = [];
        let notNullFilters: string[] = [];
        let filter = ConstructSequelizeFilters(filters, [], ['referenceId','referenceModelName','cookId','status'], nullFilters, notNullFilters);
        filters = {
          ...filter,
        }
        let data = await HttpClient.get("/centaurus/vendor-tip", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return {
          data: data?.data?.data,
          total: data?.data?.count,
        };
    }

    async getAllVendorTipsForCook(
        cookId: number,
        limit: number,
        offset: number,
        sort: any,
      ) {
        let filter = {"cookId": cookId};
        let filters = ConstructSequelizeFilters(filter, [], ['cookId']);
        let data = await HttpClient.get("/centaurus/vendor-tip", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return data?.data;
    }

    async getAllVendorTipsForCustomer(
        customerId: number,
        limit: number,
        offset: number,
        sort: any,
      ) {
        let filter = {"customerId": customerId};
        let filters = ConstructSequelizeFilters(filter, [], ['customerId']);
        let data = await HttpClient.get("/centaurus/vendor-tip", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return data?.data;
    }

    async getVendorTipById(id: number) {
        let data = await HttpClient.get(`/centaurus/vendor-tip/${id}`);
        return data;
    }

}